import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  chatIsOpen = false;

  init() {
    if (environment.environment === 'production') {
      this.addCloseChatListener();
      this.addChatMessageListener();
    }
  }

  openChat(): void {
    try {
      if (typeof window !== 'undefined' && (window as any)['zE']) {
        this.chatIsOpen = true;
        (window as any)['zE']('messenger', 'open');
      }
    } catch (error) {
      console.error(error);
    }
  }

  addCloseChatListener() {
    try {
      if (typeof window !== 'undefined' && (window as any)['zE'])
        (window as any)['zE'](
          'messenger:on',
          'close',
          () => (this.chatIsOpen = false),
        );
    } catch (error) {
      console.error(error);
    }
  }

  addChatMessageListener(): void {
    try {
      if (typeof window !== 'undefined' && (window as any)['zE'])
        (window as any)['zE'](
          'messenger:on',
          'unreadMessages',
          (count: number) => {
            if (count > 0 && !this.chatIsOpen) this.openChat();
          },
        );
    } catch (error) {
      console.error(error);
    }
  }
}
